import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 6\" id=\"icon-arrow--down\"><path d=\"M.27 1.313A.615.615 0 0 1 .08.86C.08.5.37.21.74.21c.184 0 .352.076.48.202l3.826 3.822L8.859.412A.696.696 0 0 1 9.34.21c.37 0 .66.29.66.65 0 .18-.067.333-.19.453L5.56 5.56a.723.723 0 0 1-.52.229.699.699 0 0 1-.514-.23L.27 1.314Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol